<div id="finance-details" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="page-title-wrapper">
          <!-- <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i> -->
            <div class="page-title-description">From the buttons on the left of screen select if this finance quote is for you the reseller, or if it is for your end user.
              If the pricing is for you, you can move on to the terms section. If the pricing is for your End User, enter your end user pricing for each line item under Sell Price. 
              </div>
            <div class="top-divider"></div>
        </div>
        <loading-screen *ngIf="!loadContent" [isChildLoader]="true" [showBlurTable]="false"></loading-screen>
        <div>
          <label class="tablelabel" style="margin-bottom: 25px;">Financed Items</label>
          <div class="mat-elevation-z8 shared-outer-wrapper">
            <!-- <mat-table [dataSource]="dataSourceItems">
              <ng-container matColumnDef="SKU">
                <mat-header-cell *matHeaderCellDef class="mat-flex-2"> SKU </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-flex-2"> {{element.sku}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="DESCRIPTION">
                <mat-header-cell *matHeaderCellDef class="mat-flex-2"> DESCRIPTION </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-flex-2"> {{element.description}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="QTY">
                <mat-header-cell *matHeaderCellDef class="align-right"> QTY </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right"> <input *ngIf="element.id"
                    class="qty{{element.id}} qty-input-wrapper-ddfs qty-align" type="number" [(ngModel)]="element.quantity"
                    (keypress)="isNumberKey($event)" (blur)="saveShoppingItemChange(element)"> </mat-cell>
              </ng-container>
              <ng-container matColumnDef="UNITPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> UNIT PRICE
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  {{element.unitPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="LINEPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> LINE PRICE
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [class.totalprice]="!element.id && financeType != 'enduser'"
                  class="align-right">
                  {{element.linePrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="SELLINGPRICE" *ngIf="financeType == 'enduser'">
                <mat-header-cell *matHeaderCellDef class="align-right"> SELL PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right"> <span class="dollarsign"
                    *ngIf="element.id">$&nbsp;</span><input *ngIf="element.id"
                    class="selling{{element.id}} qty-input-wrapper-ddfs" type="number"
                    [value]="element.sellPrice"
                    (blur)="element.sellPrice=$event.target.value;saveShoppingItemChange(element)"> </mat-cell>
              </ng-container>
              <ng-container matColumnDef="SELLINGLINEPRICE" *ngIf="financeType == 'enduser'">
                <mat-header-cell *matHeaderCellDef class="align-right"> LINE SELL PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  {{element.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table> -->

            <table class="white" style="width: 100%" nowrap *ngIf="financeType == 'enduser'">
              <thead>
                <tr class="row cart-title-wrapper">
                  <th scope="col" style="width: 15%; padding-left:15px;">SKU</th>
                  <th scope="col" style="width: 30%;">DESCRIPTION</th>
                  <th scope="col" class="align-center" style="width: 10%;">QTY</th>
                  <th scope="col" class="align-center" style="width: 10%;">UNIT PRICE</th>
                  <th scope="col" class="align-right" style="width: 9%;">LINE PRICE</th>
                  <th scope="col" class="align-right" style="width: 11%;">SELL PRICE</th>
                  <th scope="col" class="align-right" style="width: 13%;">LINE SELL PRICE</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let item of shoppingCartItems">
                  <tr class="row product-wrapper product-content-wrapper">
                    <td style="width: 15%; padding-left:15px;">{{item.sku}}</td>
                    <td style="width: 30%; color: #C20047;font-weight: bold;">{{item.description}}</td>
                    <!-- <td style="position:relative; padding-left: 0.75rem">{{item.description}}</td> -->
                    <td class="align-center" style="width: 10%;"><input *ngIf="item.id"
                        class="qty{{item.id}} qty-input-wrapper-ddfs qty-align" type="number" [(ngModel)]="item.quantity"
                        (keypress)="isNumberKey($event)" (blur)="saveShoppingItemChange(item)"></td>
                    <td class="align-center" style="width:10%">{{item.unitPrice | currency:'AUD':'symbol-narrow':'.2-2'}}
                    </td>
                    <td class="align-right" style="width:8%">{{item.linePrice | currency:'AUD':'symbol-narrow':'.2-2'}}
                    </td>
                    <td class="align-right" style="width:14%"><span class="dollarsign"
                        *ngIf="item.id">$&nbsp;</span><input *ngIf="item.id" class="selling{{item.id}} qty-input-wrapper-ddfs"
                        type="number" [value]="item.sellPrice"
                        (blur)="item.sellPrice=$event.target.value;saveShoppingItemChange(item)"></td>
                    <td class="align-right" style="width:10%;">
                      {{item.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

            <table class="white" style="width: 100%" nowrap *ngIf="financeType != 'enduser'">
              <thead>
                <tr class="row cart-title-wrapper">
                  <th scope="col" style="width: 15%; padding-left:15px;">SKU</th>
                  <th scope="col" style="width: 33%;">DESCRIPTION</th>
                  <th scope="col" class="align-center" style="width: 15%;">QTY</th>
                  <th scope="col" class="align-center" style="width: 10%;">UNIT PRICE</th>
                  <th scope="col" class="align-right" style="width: 12%;">LINE PRICE</th>
                  <th scope="col" class="align-right" style="width: 15%;padding-right: 15px;">LINE SELL PRICE</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let item of shoppingCartItems">
                  <tr class="row product-wrapper product-content-wrapper">
                    <td style="width: 15%; padding-left:15px;">{{item.sku}}</td>
                    <td style="width: 33%; color: #C20047;font-weight: bold;">{{item.description}}</td>
                    <!-- <td style="position:relative; padding-left: 0.75rem">{{item.description}}</td> -->
                    <td class="align-center" style="width: 15%;"><input *ngIf="item.id"
                        class="qty{{item.id}} qty-input-wrapper-ddfs qty-align" type="number" [(ngModel)]="item.quantity"
                        (keypress)="isNumberKey($event)" (blur)="saveShoppingItemChange(item)"></td>
                    <td class="align-center" style="width:10%">{{item.unitPrice | currency:'AUD':'symbol-narrow':'.2-2'}}
                    </td>
                    <td class="align-right" style="width: 12%">{{item.linePrice | currency:'AUD':'symbol-narrow':'.2-2'}}
                    </td>
                    <td class="align-right" style="width: 15%;padding-right: 15px;">
                      {{item.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

            <div class="totalrow">
              <p class="totaltext">FINANCED ITEM TOTAL</p>
              <p class="totalprice">{{totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</p>
            </div>
          </div>
        </div>

        <div class="adjustmargin" *ngIf="financeType == 'enduser'">
          <label class="tablelabel">Additional Once Off Charges</label>
          <!-- <div class="row company-introduction header-description-wrapper"> -->
            <div class="page-title-description label-padding-bottom">Enter any one time or upfront services charges including installation/
              consulting, consumables etc. You can add multiple lines here if required.</div>
          <!-- </div> -->
          <div class="mat-elevation-z8 shared-outer-wrapper">
            <!-- <mat-table [dataSource]="dataSourceAdditionalCharge">
              <ng-container matColumnDef="SKU">
                <mat-header-cell *matHeaderCellDef> SKU </mat-header-cell>
                <mat-cell *matCellDef="let element"> <input class="skuaddition{{element.rowId}} qty-input-wrapper-90"
                    [(ngModel)]="element.sku" (blur)="saveAdditionalChargeChange(element, 'skuaddition'+element.rowId)">
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="DESCRIPTION">
                <mat-header-cell *matHeaderCellDef class="mat-flex-2"> DESCRIPTION </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-flex-2"> <input
                    class="desaddition{{element.rowId}} qty-input-wrapper-90" [(ngModel)]="element.description"
                    (blur)="saveAdditionalChargeChange(element, 'desaddition'+element.rowId)">
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="QTY">
                <mat-header-cell *matHeaderCellDef class="align-right"> QTY </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right"> <input
                    class="qtyaddition{{element.rowId}} qty-input-wrapper-ddfs qty-align" type="number"
                    [(ngModel)]="element.quantity" (keypress)="isNumberKey($event)"
                    (blur)="saveAdditionalChargeChange(element, 'qtyaddition'+element.rowId)"> </mat-cell>
              </ng-container>
              <ng-container matColumnDef="UNITPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> UNIT PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right"> $&nbsp;<input
                    class="unitpriceaddition{{element.rowId}} qty-input-wrapper-ddfs" type="number"
                    [(ngModel)]="element.sellPrice" (keypress)="isNumberKey($event)"
                    (blur)="saveAdditionalChargeChange(element, 'unitpriceaddition'+element.rowId)">
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="LINEPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> LINE PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  {{element.quantity * element.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="ADDBUTTON">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  <button class="button button-red button-mid addadditionalcharge{{element.rowId}}" *ngIf="additionalCharges.length>0 && element.description==additionalCharges[additionalCharges.length-1].description" (click)="addNewRow(element)">Add</button>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="DELETEBUTTON">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  <button class="button button-red button-mid additionaldelete{{element.rowId}}"
                    (click)="deleteAdditionalChargeItem(element)">Delete</button>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumnsAdditional"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumnsAdditional;"></mat-row>
            </mat-table> -->
            <table class="white" nowrap style="width: 100%">
              <thead>
                <tr class="row cart-title-wrapper">
                  <th scope="col" style="width: 20%; padding-left: 15px">SKU</th>
                  <th scope="col" style="width: 30%">DESCRIPTION</th>
                  <th scope="col" class="align-center" style="width: 10%">QTY</th>
                  <th scope="col" class="align-center" style="width: 10%">UNIT PRICE</th>
                  <th scope="col" class="align-right" style="width: 15%">LINE PRICE</th>
                  <!-- <th scope="col" class="align-right" style="width: 12%"></th> -->
                  <th scope="col" class="align-center" style="width: 15%"><button class="button button-red button-mid addadditonalbtn" (click)="addNewRow()">Add New Line</button></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let charge of additionalCharges">
                  <tr class="row product-wrapper product-content-wrapper">
                    <td style="width: 20%; padding-left: 15px"><input
                        class="skuaddition{{charge.rowId}} qty-input-wrapper-90" [(ngModel)]="charge.sku"
                        (blur)="saveAdditionalChargeChange(charge, 'skuaddition'+charge.rowId)"></td>
                    <!-- <td style="position:relative; padding-left: 0.75rem"><input -->
                    <td style="width: 30%"><input class="desaddition{{charge.rowId}} qty-input-wrapper-90"
                        [(ngModel)]="charge.description"
                        (blur)="saveAdditionalChargeChange(charge, 'desaddition'+charge.rowId)"></td>
                    <td style="width: 10%" class="align-center"><input
                        class="qtyaddition{{charge.rowId}} qty-input-wrapper-ddfs qty-align" type="number"
                        [(ngModel)]="charge.quantity" (keypress)="isNumberKey($event)"
                        (blur)="saveAdditionalChargeChange(charge, 'qtyaddition'+charge.rowId)"></td>
                    <td style="width: 10%" class="align-center">$&nbsp;
                      <input class="unitpriceaddition{{charge.rowId}} qty-input-wrapper-ddfs" type="number"
                        [(ngModel)]="charge.sellPrice" (keypress)="isNumberKey($event)"
                        (blur)="saveAdditionalChargeChange(charge, 'unitpriceaddition'+charge.rowId)">
                    </td>
                    <td style="width: 15%" class="align-right">
                      {{charge.quantity * charge.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    <!-- <td style="width:12%; padding-left:35px;"><button
                        class="button button-red button-mid addadditionalcharge{{charge.rowId}}"
                        *ngIf="additionalCharges.length>0 && charge.sku==additionalCharges[additionalCharges.length-1].sku"
                        (click)="addNewRow(charge)">Add</button>
                    </td> -->
                    <td style="width:15%;text-align: center">
                      <!-- <button
                        class="button button-red button-mid additionaldelete{{charge.rowId}}"
                        (click)="deleteAdditionalChargeItem(charge)">Delete</button> -->
                        <span (click)="deleteAdditionalChargeItem(charge)" style="width: 23px; height: 23px;transform: translate(75%, 10%);" class="basic-icon delete-icon center-text additionaldelete{{charge.rowId}}"></span></td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
            <div class="totalrow" *ngIf="additionalCharges?.length">
              <!-- <p class="totalbtn"><button class="button button-red button-mid addadditionalcharge"
                  (click)="addNewRow()">Add</button></p> -->
              <p class="totaltext">ADDITIONAL ONCE OFF CHARGES TOTAL</p>
              <p class="totalprice">{{additionalChargeTotalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</p>
            </div>
          </div>
        </div>

        <!-- <div class="adjustmargin">
          <label class="tablelabel">Bank Details</label>
          <div class="row">
            <mat-form-field [floatLabel]="'always'" class="col-md-4">
              <input matInput placeholder="NAME" [(ngModel)]="accountName" (blur)="saveQuoteDetail()">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'" class="col-md-4">
              <input matInput class="bsbinput" placeholder="BSB" maxlength="6" [(ngModel)]="bsb" (blur)="saveQuoteDetail()">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'" class="col-md-4">
              <input matInput placeholder="ACCOUNT" maxlength="8" (keypress)="isNumberKey($event)" [(ngModel)]="accountNumber"
                (blur)="saveQuoteDetail()">
            </mat-form-field>
          </div>
        </div> -->

        <div class="adjustmargin" *ngIf="financeType == 'enduser'">
          <label class="tablelabel">Monthly Passthrough Recurring Charges</label>
          <!-- <div class="row company-introduction header-description-wrapper"> -->
            <div class="page-title-description label-padding-bottom">Enter any ongoing monthly charges to be co-billed and passed through
              to the reseller including managed helpdesk support, maintenance, recurring licencing etc.
              We will include these in the monthly billing to your end user and settle those revenues back to you on a
              monthly basis.
            </div>
          <!-- </div> -->
          <div class="mat-elevation-z8 shared-outer-wrapper">
            <!-- <mat-table [dataSource]="dataSourcePastThrough">
              <ng-container matColumnDef="SKU">
                <mat-header-cell *matHeaderCellDef> SKU </mat-header-cell>
                <mat-cell *matCellDef="let element"> <input class="skupass{{element.rowId}} qty-input-wrapper-90" [(ngModel)]="element.sku"
                    (blur)="savePastThroughCharge(element, 'skupass'+element.rowId)"> </mat-cell>
              </ng-container>
              <ng-container matColumnDef="DESCRIPTION">
                <mat-header-cell *matHeaderCellDef class="mat-flex-2"> DESCRIPTION </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-flex-2"> <input class="despass{{element.rowId}} qty-input-wrapper-90"
                    [(ngModel)]="element.description" (blur)="savePastThroughCharge(element, 'despass'+element.rowId)"> </mat-cell>
              </ng-container>
              <ng-container matColumnDef="QTY">
                <mat-header-cell *matHeaderCellDef class="align-right" style="padding-right: 32px"> QTY </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right"> <input
                    class="qtypass{{element.rowId}} qty-input-wrapper-ddfs qty-align" type="number" [(ngModel)]="element.quantity"
                    (keypress)="isNumberKey($event)" (blur)="savePastThroughCharge(element, 'qtypass'+element.rowId)"> </mat-cell>
              </ng-container>
              <ng-container matColumnDef="UNITPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> UNIT PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right"> $&nbsp;<input
                    class="sellingpass qty-input-wrapper-ddfs unitpricepass{{element.rowId}}" type="number" [(ngModel)]="element.sellPrice"
                    (keypress)="isNumberKey($event)" (blur)="savePastThroughCharge(element, 'unitpricepass'+element.rowId)"> </mat-cell>
              </ng-container>
              <ng-container matColumnDef="LINEPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> LINE PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  {{element.quantity * element.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="ADDBUTTON">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  <button class="button button-red button-mid addpasscharge{{element.rowId}}" *ngIf="passThroughCharges.length>0 && element.description==passThroughCharges[passThroughCharges.length-1].description" (click)="addPassThroughNewRow(element)">Add</button>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="DELETEBUTTON">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  <button class="button button-red button-mid passdelete{{element.rowId}}"
                    (click)="deletePassThroughChargeItem(element)">Delete</button>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumnsPass"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumnsPass;"></mat-row>
            </mat-table> -->

            <table class="white" style="width: 100%" nowrap>
              <thead>
                <tr class="row cart-title-wrapper">
                  <th scope="col" style="width: 20%; padding-left: 15px">SKU</th>
                  <th scope="col" style="width: 30%">DESCRIPTION</th>
                  <th scope="col" class="align-center" style="width: 10%">QTY</th>
                  <th scope="col" class="align-center" style="width: 10%">UNIT PRICE</th>
                  <th scope="col" class="align-right" style="width: 15%">LINE PRICE</th>
                  <!-- <th scope="col" class="align-right" style="width: 12%"></th> -->
                  <th scope="col" class="align-center" style="width: 15%"><button class="button button-red button-mid passthroughbtn" (click)="addPassThroughNewRow()">Add New Line</button></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let charge of passThroughCharges">
                  <tr class="row product-wrapper product-content-wrapper">
                    <td style="width: 20%; padding-left: 15px"><input class="skupass{{charge.rowId}} qty-input-wrapper-90"
                        [(ngModel)]="charge.sku" (blur)="savePastThroughCharge(charge, 'skupass'+charge.rowId)"></td>
                    <td style="width: 30%"><input class="despass{{charge.rowId}} qty-input-wrapper-90"
                        [(ngModel)]="charge.description" (blur)="savePastThroughCharge(charge, 'despass'+charge.id)"></td>
                    <td class="align-center" style="width: 10%"><input
                        class="qtypass{{charge.rowId}} qty-input-wrapper-ddfs qty-align" type="number"
                        [(ngModel)]="charge.quantity" (keypress)="isNumberKey($event)"
                        (blur)="savePastThroughCharge(charge, 'qtypass'+charge.rowId)"></td>
                    <td class="align-center" style="width: 10%">$&nbsp;<input
                        class="sellingpass qty-input-wrapper-ddfs unitpricepass{{charge.rowId}}" type="number"
                        [(ngModel)]="charge.sellPrice" (keypress)="isNumberKey($event)"
                        (blur)="savePastThroughCharge(charge, 'unitpricepass'+charge.rowId)"></td>
                    <td class="align-right" style="width: 15%">
                      {{charge.quantity * charge.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    <!-- <td style="width:12%; padding-left:35px;"><button
                        class="button button-red button-mid addpasscharge{{charge.rowId}}"
                        *ngIf="passThroughCharges.length>0 && charge.description==passThroughCharges[passThroughCharges.length-1].description"
                        (click)="addPassThroughNewRow(charge)">Add</button>
                    </td> -->
                    <td style="width:15%; text-align: center">
                      <!-- <button
                        class="button button-red button-mid passdelete{{charge.rowId}}"
                        (click)="deletePassThroughChargeItem(charge)">Delete</button> -->
                        <span (click)="deletePassThroughChargeItem(charge)" style="width: 23px; height: 23px;transform: translate(75%, 10%);" class="basic-icon delete-icon center-text passdelete{{charge.rowId}}"></span></td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

            <div class="totalrow" *ngIf="passThroughCharges?.length">
              <!-- <p class="totalbtn"><button class="button button-red button-mid addadditionalcharge"
                  (click)="addPassThroughNewRow()">Add</button></p> -->
              <p class="totaltext">MONTHLY PASSTHROUGH RECURRING CHARGES</p>
              <p class="totalprice">{{passThroughChargeTotalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</p>
            </div>
          </div>
        </div>

        <div class="termtable">
          <label id="example-radio-group-label" class="tablelabel">Terms</label>
          <!-- <div class="row company-introduction header-description-wrapper"> -->
            <div class="page-title-description">Select your desired term. Note that if you have included any monthly
              recurring passthrough charges they are included in the monthly pricing listed below. Note that any software
              or warranty terms cannot be selected for longer than the term of the product itself. </div>
          <!-- </div> -->
          <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group term-group" *ngIf="terms?.length">
            <mat-radio-button class="example-radio-button" (click)="selectTerm(term)" *ngFor="let term of terms"
              [value]="term?.termId" [checked]="selectedTerm?.termId == term?.termId">
              <span class="termvalue">{{term?.description}}</span>
              <span class="termprice term{{term?.termId}}"
                *ngIf="term?.termId!=1">{{term?.amount | currency:'AUD':'symbol-narrow':'.2-2'}}/mth</span>
              <span class="termprice term{{term?.termId}}"
                *ngIf="term?.termId==1">&nbsp;</span>
            </mat-radio-button>
          </mat-radio-group>
          <div class="noData-wrapper" *ngIf="!terms?.length">
            <div>
              <img src="../images/new_ui/no-endUser.png">
            </div>
            <label class="noData-label">
              {{termsMessage?termsMessage:"We couldn't find any terms"}}
            </label>
          </div>
        </div>

        <button class="button button-red button-large middleposition" (click)="confirmFinancialDetails()"
          *ngIf="selectedTerm">Next</button>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>